module.exports = __webpack_public_path__ + "static/image3-2f54afe2a54d718af76f3bc338c199f3.jpg";